// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?ver=" + "cdb0a0c7a07682a3c746" + "";
};